import { Directive, ElementRef, Renderer2 } from '@angular/core';

/*
  Generated class for the MudaValorPergunta directive.

  See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
  for more info on Angular 2 Directives.
*/
@Directive({
  selector: '[muda-valor-pergunta]', // Attribute selector
   host: {
    '(click)': 'onClick()'
  }
})
export class MudaValorPergunta {
  el:any;

  constructor(_el: ElementRef) {
    this.el = _el;
  }

  onClick(){
    this.el.nativeElement=+`<p>teste</p>`;
  }

}



// WEBPACK FOOTER //
// ./src/components/muda-valor-pergunta/muda-valor-pergunta.ts